import editableCheckbox from "./editableCheckbox.component";

const editableCheckboxModule = angular
  .module("app.components.editableCheckbox", [])
  .component("editableCheckbox", editableCheckbox);

export default editableCheckboxModule;



// WEBPACK FOOTER //
// ./src/components/editableCheckbox/editableCheckbox.module.js